import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    chartHeader: [],
    chartData: [],
    dashboardData: [],
    itemsList: [],
    leastItemsList: [],
    latestSaledItems: [],
  },
  getters: {
    chartHeader: (state) => state.chartHeader,
    chartData: (state) => state.chartData,
    dashboardData: (state) => state.dashboardData,
    itemsList: (state) => state.itemsList,
    leastItemsList: (state) => state.leastItemsList,
    latestSaledItems: (state) => state.latestSaledItems,
  },
  actions: {
    fetchChartHeader({ commit }, { model1, params }) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/SaleReportsQuery/chartHeader?" + model1 + params)
          .then((r) => {
            commit("setChartHeader", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchChartData({ commit }, { model, isByCount, params }) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Sales/api/SaleReportsQuery/chart?" +
              model +
              "&" +
              "isByCount=" +
              isByCount +
              "&" +
              params
          )
          .then((r) => {
            commit("setChartData", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchChartDataForDraftOrder({ commit }, { model2, isByCount, params }) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Sales/api/SaleReportsQuery/chart/draft-orders?" +
              model2 +
              "&" +
              "isByCount=" +
              isByCount +
              "&" +
              params
          )
          .then((r) => {
            commit("setChartData", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchDashboardReport({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Sales/api/ContractsQuery/0/0/0/0/" + id)
          .then((r) => {
            commit("setDashboardData", r.data);
            resolve(r.data);
          })
          .catch((e) => reject(e));
      });
    },
    fetchBestsellersItems({ commit }) {
      return ajax
        .get(
          "Sales/api/DraftOrdersQuery/ProductSaleInfo?SortingFieldName=count&SortingOrderType=desc&Take=5&Skip=0"
        )
        .then((r) => {
          commit("setItemList", r.data.data);
        });
    },
    fetchLeastSaleItems({ commit }) {
      return ajax
        .get(
          "Sales/api/DraftOrdersQuery/ProductSaleInfo?SortingFieldName=count&SortingOrderType=asc&Take=5&Skip=0"
        )
        .then((r) => {
          commit("setLeastItemList", r.data.data);
        });
    },
    fetchLatestSaledItems({ commit }) {
      return ajax
        .get("Sales/api/BasketsQuery/LatestBaskets?Take=10&Skip=0")
        .then((r) => {
          commit("setLatestSaledItems", r.data.data);
        });
    },
    OrderItemsQuery({ commit }, model) {
      return ajax
        .get("Sales/api/OrdersQuery/orderItems?Take=10&Skip=0", model)
        .then((r) => {});
    },
    fetchOrdersPerSegmentChartData({ commit }) {
      return ajax
        .get(
          "/Sales/api/SaleReportsQuery/orders-per-segment-from-first-of-this-month"
        )
        .then((r) => r.data);
    },
    fetchOrdersAndSaleTargetsPerSegmentChartData({ commit }) {
      return ajax
        .get(
          "/Sales/api/SaleReportsQuery/orders-per-segment-and-sale-targets-from-first-of-this-month"
        )
        .then((r) => r.data);
    },
    fetchQuotaPerSegmentChartData({ commit }) {
      return ajax
        .get("/Sales/api/QuotaTransactionsQuery/quota-per-inventory-of-product")
        .then((r) => r.data);
    },
    fetchInventoryBalanceChartData({ commit }) {
      return ajax
        .get(
          "/Inventory/api/InventoryTransactionsQuery/inventory-balances-for-each-segment"
        )
        .then((r) => r.data);
    },
    fetchPackageStatesChartData({ commit }) {
      return ajax
        .get("/Shipping/api/PackagesQuery/package-state-from-first-of-month")
        .then((r) => r.data);
    },
    fetchOrdersPerSegmentAndSaleTargetsOfSalePersonsChartData({ commit }) {
      return ajax
        .get(
          "/Sales/api/SaleReportsQuery/orders-per-segment-and-sale-targets-of-sale-person-from-first-of-this-month"
        )
        .then((r) => r.data);
    },
    fetchOrdersOfSalesTargetsOfSalePersonsChartData({ commit }) {
      return ajax
        .get(
          "/Sales/api/SaleReportsQuery/orders-of-sales-targets-of-sale-person-from-first-of-this-month"
        )
        .then((r) => r.data);
    },
  },
  mutations: {
    setChartHeader(state, data) {
      state.chartHeader = data;
    },
    setChartData(state, data) {
      state.chartData = data;
    },
    setDashboardData(state, data) {
      state.dashboardData = data;
    },
    setItemList(state, data) {
      state.itemsList = data;
    },
    setLeastItemList(state, data) {
      state.leastItemsList = data;
    },
    setLatestSaledItems(state, data) {
      state.latestSaledItems = data;
    },
  },
};
